import { IPaso, Paso } from "./paso.model";

export interface IEncuesta {
  idEncuesta: string;
  nombre: string;
  descripcion: string;
}

export class Encuesta {
  idEncuesta: string;
  nombre: string;
  descripcion: string;

  constructor(data: IEncuesta) {
    this.idEncuesta = data.idEncuesta;
    this.nombre = data.nombre;
    this.descripcion = data.descripcion;
  }
}
